/* global google */

import $                      from 'jquery';
import slick                  from 'slick-carousel';
import loadGoogleMapsApi      from 'load-google-maps-api';
import mapOptions             from './maps/options';
import zoomControls           from './maps/zoom_controls';
import defaultMarkerImage     from 'images/markers/default@2x.png';
import arrows from './sliders/arrows';

const _globals = {
  mapSelector: '.js-mediaTabMap',
  mapOps: mapOptions,
  api: {
    key: 'AIzaSyCQnfrDrya4bZRzCn4EfBimwPDcbvGh2fo'
  }
};

const _createMap = ($mapSelector = document.querySelector(_globals.mapSelector)) => {

  const thisLocation = {
    lat: parseFloat($mapSelector.dataset.lat),
    lng: parseFloat($mapSelector.dataset.lng)
  };

  const map = new google.maps.Map($mapSelector, {
    ..._globals.mapOps,
    zoom: 10
  });

  const defaultMarker = {
    url: defaultMarkerImage,
    scaledSize: new google.maps.Size(45, 50)
  };

  const marker = new google.maps.Marker({
    size: new google.maps.Size(45, 50),
    icon: defaultMarker,
    position: thisLocation,
    map: map
  });

  zoomControls(_globals.mapSelector, map);
  map.setCenter(marker.getPosition());

};

const _createSlickInstances = () => {

  const $slider = $('.js-mediaTabMain');
  const $sliderNav = $('.js-mediaTabNav');
  const $venueGallery = $('.js-venueGallery');
  const $sectionGallery = $('.js-sectionGallery');

  const venueGallerySlickOptions = {
    ...arrows,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    rows: 0,
    responsive: [
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  const sectionGallerySlickOptions = {
    ...arrows,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    rows: 0,
    responsive: [
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  // remove controls from videos in sliderNav
  $('.js-mediaTabNav video').removeAttr('controls');

  $slider.on('beforeChange', () => {
    // stop all youtube videos playing when changing slides
    $('.js-youtubeVideo').each(function(i) {
      $('.js-youtubeVideo')[i].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
    });
    // stop all HTML5 videos playing when changing slides
    $('.js-mediaTabMain video').each(function() {
      $(this).get(0).pause();
    });

  });

  $slider.slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    adaptiveHeight: true,
    focusOnSelect: true,
    rows: 0,
    infinite: false,
    asNavFor: $sliderNav
  });

  $sliderNav.slick({
    ...arrows,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    adaptiveHeight: true,
    focusOnSelect: true,
    rows: 0,
    asNavFor: $slider,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      }
    ]
  });

  $venueGallery.slick(venueGallerySlickOptions);
  $sectionGallery.slick(sectionGallerySlickOptions);

  // Printing: slick carousels created in hidden tabs can render overlapped in PDFs.
  // For print/PDF output we temporarily destroy the section-gallery slick instances,
  // letting the existing grid markup render naturally, then restore slick afterwards.
  const setupGalleryPrintMode = () => {
    if (!$sectionGallery.length && !$venueGallery.length) return;

    let isPrinting = false;

    const destroyForPrint = () => {
      if (isPrinting) return;
      isPrinting = true;

      $venueGallery.each(function() {
        const $gallery = $(this);
        if ($gallery.hasClass('slick-initialized')) {
          $gallery.slick('unslick');
        }
      });

      $sectionGallery.each(function() {
        const $gallery = $(this);
        if ($gallery.hasClass('slick-initialized')) {
          $gallery.slick('unslick');
        }
      });
    };

    const restoreAfterPrint = () => {
      if (!isPrinting) return;
      isPrinting = false;

      $venueGallery.each(function() {
        const $gallery = $(this);
        if (!$gallery.hasClass('slick-initialized')) {
          $gallery.slick(venueGallerySlickOptions);
        }
      });

      $sectionGallery.each(function() {
        const $gallery = $(this);
        if (!$gallery.hasClass('slick-initialized')) {
          $gallery.slick(sectionGallerySlickOptions);
        }
      });
    };

    window.addEventListener('beforeprint', destroyForPrint);
    window.addEventListener('afterprint', restoreAfterPrint);

    // Some browsers only reliably signal print state via matchMedia.
    if (window.matchMedia) {
      const mql = window.matchMedia('print');
      const onChange = event => {
        if (event.matches) {
          destroyForPrint();
        } else {
          restoreAfterPrint();
        }
      };

      if (mql.addEventListener) {
        mql.addEventListener('change', onChange);
      } else if (mql.addListener) {
        mql.addListener(onChange);
      }
    }
  };

  const $sectionGalleryImages = $(".c-mediaTabs__sectionGallery .imageContainer");

  $sectionGalleryImages.on('keydown', function(event) {
    var key = event.key;

    if (key === 'Tab') {
      var $sectionGallery = $(this).closest('.js-sectionGallery');
      if (!$sectionGallery.hasClass('slick-initialized')) return;
      if (event.shiftKey) {
        $sectionGallery.slick('slickPrev');
      }
      else {
        $sectionGallery.slick('slickNext');
      }
    }
  });

  window.onclick = function (event) {
    if(event.target.id == 'panorama-close' || event.target.id == 'image-popup-close') {
      $venueGallery.each(function() {
        const $gallery = $(this);
        if ($gallery.hasClass('slick-initialized')) {
          $gallery.slick('refresh');
        }
      });

      $sectionGallery.each(function() {
        const $gallery = $(this);
        if ($gallery.hasClass('slick-initialized')) {
          $gallery.slick('refresh');
        }
      });
    }
  };

  setupGalleryPrintMode();
};

const mediaTabs = () => {

  _createSlickInstances();

  if (!document.querySelector(_globals.mapSelector)) return;

  loadGoogleMapsApi(_globals.api).then(googleMaps => {

    window.google = {};
    window.google.maps = googleMaps;
    _createMap();

  }).catch(error => {
    console.error(error);
  });

};

export default mediaTabs;
